/* eslint-disable no-undef */
/**
 * 高德地图
 */
const map = new AMap.Map('map', {
  zoom: 100, // 级别
  center: [113.326558, 23.126633] // 中心点坐标
  // viewMode: '3D'// 使用3D视图
})
// 创建一个 Marker 实例：
const marker = new AMap.Marker({
  position: new AMap.LngLat(113.326558, 23.126633), // 经纬度对象，也可以是经纬度构成的一维数组[113.326558, 23.126633]
  title: '深圳市心云科技有限公司'
})

// 将创建的点标记添加到已有的地图实例：
map.add(marker)
// 设置label标签
// label默认蓝框白底左上角显示，样式className为：amap-marker-label
marker.setLabel({
  offset: new AMap.Pixel(0, 10), // 设置文本标注偏移量
  content: '<div class=\'info\'>深圳市心云科技有限公司</div>', // 设置文本标注内容
  direction: 'right' // 设置文本标注方位
})